import { api } from './configs/axiosConfig';

const endPoint = "/catalogs";

export const catalogAPI = {
    getSubCategories: async function (isFood,isBeverages) {
        const reponse = await api.request({
            url: `${endPoint}/subcategories`,
            method: 'GET',
            params: { isFood, isBeverages }
        });

        return reponse.data;
    },
    getItems: async function (subCatCode) {
        const reponse = await api.request({
            url: `${endPoint}/items`,
            method: 'GET',
            params: { subCatCode }
        });

        return reponse.data;
    },
    searchItems: async function (key) {
        const reponse = await api.request({
            url: `${endPoint}/search-items`,
            method: 'GET',
            params: { key }
        });

        return reponse.data;
    }
}